import React, { createRef, useEffect, useRef, useState } from "react";
import { Formik, Form } from "formik";
import "./notification.css";
import NotificationCard from "../../components/NotificationCard/NotificationCard";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import close from "../../images/icons/close.png";
import CustomInput from "../../components/CustomInput/CustomInput";
import CustomButton from "../../components/CustomButton/custombutton";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import add from "../../images/icons/add.png";
import * as Yup from "yup";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import Table from "../../components/Table/Table";
import FileUpload from "../../components/FileUpload/FileUpload";
import getToken from "../../pages/getToken";

const Notification = () => {
  const [keyword, setKeyword] = useState("");
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const member = [
    {
      label: "All Member",
      value: 0,
    },
    {
      label: "Silver",
      value: 1,
    },
    {
      label: "Gold",
      value: 2,
    },
    {
      label: "Diamond",
      value: 3,
    },
  ];

  const refPreviewNotiFiles = useRef(false);
  const [showAddNoti, setShowAddNoti] = useState(false);
  const [showEditNoti, setShowEditNoti] = useState(false);
  const refNotiForm = useRef(null);
  const refMemberSelectList = useRef();
  const notificationId = useRef(0);
  const [notiDetail, setNotiDetail] = useState({});

  const clickAddNoti = (e) => {
    e.stopPropagation();
    if (showEditNoti) {
      setShowEditNoti(false);
      setTimeout(() => setShowAddNoti(true), 100);
    } else {
      setShowAddNoti(true);
    }
    setNotiDetail({});
  };
  const clickBtnClose = () => {
    setShowAddNoti(false);
    setShowEditNoti(false);
  };

  let AddNotificationValidation = Yup.object().shape({
    title: Yup.string().required("Please enter the title."),
    image: Yup.string().nullable().required("Please choose the image."),
    description: Yup.string().required("Please enter the description."),
    memberType: Yup.number().required("Please select the member."),
  });

  let brandId = localStorage.getItem("brandId");

  const handleNotiSubmit = (values, actions) => {
    let notification = {
      brandID: brandId,
      ...values,
      image: values.image.replace(/^data:(.*,)?/, ""),
    };
    api
      .post("Admin/CreateNotificationByAdmin", notification, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("Announcement saved successfully!!");

              // reset the inputs and clear values
              actions.resetForm();
              values = {};
              refMemberSelectList.current.selectOption("");
              for (let i = 0; i < refNotiForm.current.length - 2; i++) {
                refNotiForm.current[i].value = "";
              }
              refPreviewNotiFiles.current = false;

              setShowAddNoti(false);

              // refresh noti list
              getNotificationList();
              getNotificationCardList();
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        )
      );
    actions.setSubmitting(false);
  };

  const clickBtnEditNoti = (e, id) => {
    e.stopPropagation();
    clickBtnClose();
    getNotiDetail(id);
  };

  const clickBtnSend = (e, id, type) => {
    e.stopPropagation();
    const memberType = parseInt(type);

    api
      .post(
        `Admin/SendNotiWithTier?NotificationId=${id}&Type=${memberType}`,
        {},
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.statusCode === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.statusCode === 200) {
              if (response.data.value.data == "True") {
                alert("Sent Announcement Successfully!");
              } else {
                alert("Failed to send announcement. Please reduce message size.");
              }
              console.log(response.data);
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            alert(error);
          }
        );
      });
  };

  const getNotiDetail = (id) => {
    api
      .get("Admin/GetNotificationDetail", { NotificationId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setNotiDetail(response.data.value.data);
              setShowEditNoti(true);
              notificationId.current = id;
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const editNotiSubmit = (values, actions) => {
    console.log(values);

    let notification = {
      id: notificationId.current,
      ...values,
      image: values.image.replace(/^data:(.*,)?/, ""),
    };
    console.log(notification);

    api
      .post("Admin/UpdateNotficationByAdmin", notification, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("Announcement updated successfully!!");
              setShowEditNoti(false);

              // getNotiDetail(notificationId.current);
              getNotificationCardList();
              getNotificationList();
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
    actions.setSubmitting(false);
  };

  const [paramNotificationList, setParamNotificationList] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const refNotificationTable = createRef();

  const [notificationData, setNotificationData] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const getNotificationList = (value = paramNotificationList) => {
    value.keyword = keyword || "";
    setNotificationData({
      ...notificationData,
      isLoading: true,
    });
    api
      .post("Admin/GetNotificationListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setNotificationData({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data.data && response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
              refPreviewNotiFiles.current = false;
            } else {
              setNotificationData({
                isLoading: false,
                grouping: false,
                limit: apiUtil.getDefaultPageSize(),
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const [notificationCardList, setNotificationCardList] = useState([]);
  const [paramNotification, setParamNotification] = useState({
    keyword: "",
    rowLimit: 7,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });
  console.log(setParamNotification);
  const getNotificationCardList = (value = paramNotification) => {
    setNotificationData({
      ...notificationData,
      isLoading: true,
    });

    api
      .post("Admin/GetNotificationListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setNotificationCardList(
                response.data.data.data && response.data.data.data.length > 0
                  ? response.data.data.data
                  : []
              );
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  useEffect(() => {
    getNotificationList();
    getNotificationCardList();
  }, [paramNotificationList]);

  return (
    <div className="notification">
      {showAddNoti || showEditNoti ? (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">Announcement</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>
          {/* <div className="px-2 pb-3 mt-3">
            <div className="card" style={{ width: "100%" }}>
              <div className="card-body"> */}
          <Formik
            initialValues={{
              title: notiDetail.title ? notiDetail.title : "",
              image: notiDetail.image ? notiDetail.image : null,
              description: notiDetail.description ? notiDetail.description : "",
              memberType:
                notiDetail.memberType !== undefined
                  ? notiDetail.memberType
                  : "",
            }}
            validationSchema={AddNotificationValidation}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              if (showEditNoti) {
                editNotiSubmit(values, actions);
              } else {
                handleNotiSubmit(values, actions);
              }
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form
                ref={refNotiForm}
                className="row form-container notification-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="title"
                    type="text"
                    label="Title"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-6 mt-2">
                  <FileUpload
                    label="Image"
                    name="image"
                    placeholder="Choose an Image"
                    handleFile={(file) => {
                      const reader = new FileReader();
                      refPreviewNotiFiles.current = true;

                      reader.onload = () => {
                        if (typeof reader.result === "string") {
                          const encoded_image = reader.result;
                          setFieldValue("image", encoded_image);
                        } else {
                          console.error(
                            "Error: FileReader result is not a string."
                          );
                        }
                      };
                      reader.readAsDataURL(file[0]);
                    }}
                    refPreviewFiles={refPreviewNotiFiles}
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="description"
                    label="Description"
                    textarea="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-between noti_select">
                    <CustomSelect
                      refSelect={refMemberSelectList}
                      options={member}
                      name="memberType"
                      isClearable={true}
                      from="noti_select"
                      value={member.find(
                        (option) => option.value === values.memberType
                      )}
                    />
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnSave">
                        {showAddNoti ? "Create" : "Update"}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {/* </div>
            </div>
          </div> */}
        </>
      ) : (
        //  Carousel
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          responsive={responsive}
          ssr={true}
          infinite={true}
          keyBoardControl={true}
          containerClass="carousel-container noti-card-carousel"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {notificationCardList.map((notification) => {
            console.log(notification);
            const dateArray = notification.createdDate
              .split(" ")[0]
              .replaceAll("/", " ")
              .split(" ");
            const newDate = new Date(
              dateArray[2],
              dateArray[1] - 1,
              dateArray[0]
            );
            let createdDate = apiUtil.getDateShortMonthFormat(newDate);

            let member = "";

            switch (notification.memberType) {
              case "0":
                member = "All Member";
                break;
              case "1":
                member = "Silver";
                break;
              case "2":
                member = "Gold";
                break;
              case "3":
                member = "Diamond";
                break;
            }

            return (
              <NotificationCard
                title={notification.title}
                date={createdDate}
                memberType={member}
                description={notification.description}
                key={notification.id}
                onSendNoti={(e) =>
                  clickBtnSend(e, notification.id, notification.memberType)
                }
                onClick={(e) => clickBtnEditNoti(e, notification.id)}
              />
            );
          })}
        </Carousel>
      )}

      <div className=" Actions space_between">
        <h6 className="title_text mt-2">Announcement</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => getNotificationList()}
          />
          {!showAddNoti && (
            <CustomButton
              icon={add}
              text="Create Announce"
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddNoti(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container notification_table">
        <Table
          key={notificationData.total}
          ref={refNotificationTable}
          maxBodyHeight={notificationData.limit * 70}
          isLoading={notificationData.isLoading}
          grouping={notificationData.grouping}
          limit={notificationData.limit}
          data={notificationData.data}
          total={notificationData.total}
          page={notificationData.page}
          onPageChange={(page) => {
            setParamNotificationList({
              currentPage: page,
            });
            getNotificationList(paramNotificationList);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex =
                  (notificationData.page - 1) * notificationData.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "60px",
              align: "center",
            },
            {
              title: "Image",
              render: (row) => {
                if (row.image == "") {
                  return <div className="text-center">-</div>;
                }
                return (
                  <img
                    src={row.image}
                    alt=""
                    className="d-block imgNotification"
                  />
                );
              },
            },
            {
              title: "Title",
              field: "title",
            },
            {
              title: "Date",
              render: (row) => {
                const dateArray = row.createdDate
                  .split(" ")[0]
                  .replaceAll("/", " ")
                  .split(" ");
                const newDate = new Date(
                  dateArray[2],
                  dateArray[1] - 1,
                  dateArray[0]
                );
                return apiUtil.getDateShortMonthFormat(newDate);
              },
            },
            {
              title: "Description",
              field: "description",
              width: "270px",
            },
            {
              title: "Member",
              render: (row) => {
                let member = "";

                switch (row.memberType) {
                  case "0":
                    member = "All Member";
                    break;
                  case "1":
                    member = "Silver";
                    break;
                  case "2":
                    member = "Gold";
                    break;
                  case "3":
                    member = "Diamond";
                    break;
                }
                return (
                  <CustomButton
                    text={member}
                    from="Noti"
                    addIcon={false}
                    className="disabled"
                  />
                );
              },
              sorting: false,
              align: "center",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Notification;
